import { useState, useEffect, createContext } from "react";

export const ChartContainerSizeContext = createContext({
  chartWidth: 0,
  chartHeight: 0,
});

interface GenericResizeContainerProps {
  chartContainerRef: React.RefObject<HTMLElement>;
  children: React.ReactNode;
}

export default ({ chartContainerRef, children }: GenericResizeContainerProps) => {
  const [chartContainerSize, setChartContainerSize] = useState<{
    chartWidth: number;
    chartHeight: number;
  }>({ chartWidth: 0, chartHeight: 0 });

  useEffect(() => {
    const node = chartContainerRef.current;
    if (!node) return;

    const updateChartContainerSize = () => {
      const width = node.clientWidth;
      const height = node.clientHeight - 10;

      setChartContainerSize((prev) => {
        if (prev.chartWidth !== width || prev.chartHeight !== height) {
          return { chartWidth: width, chartHeight: height };
        }
        return prev;
      });
    };

    updateChartContainerSize();

    const resizeObserver = new ResizeObserver(() => {
      updateChartContainerSize();
    });

    resizeObserver.observe(node);

    return () => {
      resizeObserver.disconnect();
    };
  });

  return (
    <ChartContainerSizeContext.Provider value={chartContainerSize}>
      {children}
    </ChartContainerSizeContext.Provider>
  );
};
